import { createSlice } from "@reduxjs/toolkit";

export const gstrSlice = createSlice({
  name: "gstr",
  initialState: {},
  reducers: {},
});

export default gstrSlice.reducer;
export const {} = gstrSlice.actions;
